
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-20">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-12 sm:mb-20 pb-6 sm:pb-8 border-b border-gray-800">
          <div className="flex items-center gap-2 sm:gap-3 mb-4 md:mb-0">
            <img 
              src="https://static.readdy.ai/image/096be9c57cd562040b50de9c711536fc/e73311cce7ef728ccc6bdfd961a34f39.png" 
              alt="Green Leads Network" 
              className="h-8 sm:h-10 w-auto brightness-0 invert"
            />
            <span className="text-base sm:text-xl font-bold">Green Leads Network</span>
          </div>
          <p className="text-sm sm:text-base text-gray-400">Instagram Lead Generation for Landscaping Companies</p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 sm:gap-12 mb-12 sm:mb-20">
          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-4 sm:mb-6">Services</h4>
            <ul className="space-y-3 sm:space-y-4">
              <li><a href="#" className="text-sm sm:text-base text-gray-400 hover:text-white transition-all hover:translate-x-1 inline-block cursor-pointer">Campaign Setup</a></li>
              <li><a href="#" className="text-sm sm:text-base text-gray-400 hover:text-white transition-all hover:translate-x-1 inline-block cursor-pointer">Content Creation</a></li>
              <li><a href="#" className="text-sm sm:text-base text-gray-400 hover:text-white transition-all hover:translate-x-1 inline-block cursor-pointer">Ad Management</a></li>
              <li><a href="#" className="text-sm sm:text-base text-gray-400 hover:text-white transition-all hover:translate-x-1 inline-block cursor-pointer">Analytics</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-4 sm:mb-6">Company</h4>
            <ul className="space-y-3 sm:space-y-4">
              <li><a href="#about" className="text-sm sm:text-base text-gray-400 hover:text-white transition-all hover:translate-x-1 inline-block cursor-pointer">About Us</a></li>
              <li><a href="#testimonials" className="text-sm sm:text-base text-gray-400 hover:text-white transition-all hover:translate-x-1 inline-block cursor-pointer">Success Stories</a></li>
              <li><a href="#" className="text-sm sm:text-base text-gray-400 hover:text-white transition-all hover:translate-x-1 inline-block cursor-pointer">Pricing</a></li>
              <li><a href="#contact" className="text-sm sm:text-base text-gray-400 hover:text-white transition-all hover:translate-x-1 inline-block cursor-pointer">Contact</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-base sm:text-lg font-semibold mb-4 sm:mb-6">Resources</h4>
            <ul className="space-y-3 sm:space-y-4">
              <li><a href="#" className="text-sm sm:text-base text-gray-400 hover:text-white transition-all hover:translate-x-1 inline-block cursor-pointer">Blog</a></li>
              <li><a href="#" className="text-sm sm:text-base text-gray-400 hover:text-white transition-all hover:translate-x-1 inline-block cursor-pointer">Case Studies</a></li>
              <li><a href="#" className="text-sm sm:text-base text-gray-400 hover:text-white transition-all hover:translate-x-1 inline-block cursor-pointer">Marketing Tips</a></li>
              <li><a href="#" className="text-sm sm:text-base text-gray-400 hover:text-white transition-all hover:translate-x-1 inline-block cursor-pointer">Help Center</a></li>
            </ul>
          </div>

          <div className="col-span-2 md:col-span-1">
            <p className="text-lg sm:text-xl font-serif mb-2">© Green Leads Network 2025</p>
            <p className="text-xs sm:text-sm text-gray-400 mb-6">All rights reserved</p>
            <div className="flex gap-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors hover:underline cursor-pointer">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-instagram-line text-2xl"></i>
                </div>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors hover:underline cursor-pointer">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-linkedin-line text-2xl"></i>
                </div>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors hover:underline cursor-pointer">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-facebook-line text-2xl"></i>
                </div>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors hover:underline cursor-pointer">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-twitter-x-line text-2xl"></i>
                </div>
              </a>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6 sm:gap-8 items-center">
          <div className="rounded-2xl sm:rounded-3xl overflow-hidden">
            <img 
              src="https://public.readdy.ai/ai/img_res/f158d1f843b6bd36149f7b217a2bdfd6.jpg" 
              alt="Our Team"
              className="w-full h-48 sm:h-60 object-cover object-top"
            />
          </div>

          <div className="md:col-span-1 space-y-2">
            <p className="text-xl sm:text-3xl font-serif text-white leading-snug">
              Grow your landscaping business with Instagram lead generation
            </p>
          </div>

          <div className="space-y-3">
            <p className="text-xs sm:text-sm text-gray-400 leading-relaxed">
              Subscribe to our newsletter for marketing tips
            </p>
            <form className="flex flex-col sm:flex-row gap-2" data-readdy-form>
              <input 
                type="email" 
                name="email"
                placeholder="Enter your email" 
                className="flex-1 bg-transparent border-2 border-gray-700 rounded-xl px-4 sm:px-6 py-2.5 sm:py-3 text-sm sm:text-base text-white placeholder-gray-500 focus:outline-none focus:border-emerald-500 transition-colors"
                required
              />
              <button 
                type="submit"
                className="bg-emerald-600 hover:bg-emerald-700 rounded-xl px-6 sm:px-8 py-2.5 sm:py-3 transition-colors flex items-center justify-center whitespace-nowrap cursor-pointer"
              >
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xl text-white"></i>
                </div>
              </button>
            </form>
          </div>
        </div>

        <div className="mt-12 sm:mt-16 pt-6 sm:pt-8 border-t border-gray-800 text-center">
          <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-xs sm:text-sm text-gray-500 hover:text-gray-300 transition-colors cursor-pointer">
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
